import axios from '@/utils/request'

export default {
  addCoupon: data => axios({ url: '/api/product/coupon/coupon', method: 'post', data }), // 创建优惠券
  getCouponList: data => axios({ url: '/api/product/coupon/getCouponList', method: 'post', data }), // 获取优惠券列表
  setCouponStatus: data => axios({ url: '/api/product/coupon/couponStatus', method: 'put', data }), // 更新优惠券状态 (0 结束活动)
  getCouponDetail: (id, params) => axios({ url: `/api/product/coupon/couponDetail/${id}`, method: 'get', params }), // 更新优惠券状态 (0 结束活动)
  getCouponOrderList: data => axios({ url: `/api/product/coupon/getCouponOrderList`, method: 'post', data }), // 获取优惠券订单列表
  editCoupon: data => axios({ url: `/api/product/coupon/coupon`, method: 'put', data }), // 编辑优惠券
}
